export const chartColorVariants = [
    'primary',
    'warning',
    'danger',
    'success',
    'info',
    'dark',
    'secondary',
]
